module.exports = __webpack_public_path__ + "img/select-infield-mezzanine.3c75bd16.jpg";